<template>
  <div v-if="data">
    <Top />
    <img class="img-banner" src="@/assets/img/jpgs/fhabian-whatisfh.jpg"
      v-if="$route && $route.path.includes('whatisfh')" />
    <img class="img-banner" src="@/assets/img/jpgs/fhabian-aboutapp.jpg"
      v-if="$route && $route.path.includes('aboutapp')" />
    <img class="img-banner" src="@/assets/img/jpgs/fhabian-research.jpg"
      v-if="$route && $route.path.includes('helpresearch')" />
    <img class="img-banner" src="@/assets/img/jpgs/fhabian-contact.jpg"
      v-if="$route && $route.path.includes('contact')" />
    <div class="container">
      <div class="clearfix"></div>
      <br />
      <!-- What is FH? -->
      <div class="row" v-if="page === 'whatisfh'">
        <div class="col-sm"></div>
        <div class="col-md-8">
          <h2 class="text-primary-fh text-left" v-html="data.faq.whatisfh"></h2>
          <div class="clearfix"></div>
          <h4 class="text-danger" v-html="data.faq.subheading1"></h4>
          <p v-html="data.faq.bodytext1"></p>
          <h4 class="text-danger" v-html="data.faq.subheading2"></h4>
          <p v-html="data.faq.bodytext2"></p>
        </div>
        <div class="col-sm"></div>
      </div>
      <!-- How to treat FH? -->
      <div class="row" v-if="page === 'treatfh'">
        <div class="col-sm"></div>
        <div class="col-md-8">
          <h2 class="text-primary-fh text-left" v-html="data.faq.howtotreatfh"></h2>
          <div class="clearfix"></div>
          <h4 class="text-danger" v-html="data.faq.subheading3"></h4>
          <p v-html="data.faq.bodytext3"></p>
          <h4 class="text-danger" v-html="data.faq.subheading4"></h4>
          <p v-html="data.faq.bodytext4"></p>
        </div>
        <div class="col-sm"></div>
      </div>
      <!-- About this app -->
      <div class="row" v-if="page === 'aboutapp'">
        <div class="col-sm"></div>
        <div class="col-md-8">
          <h2 class="text-primary-fh text-left" v-html="data.faq.aboutapp"></h2>
          <div class="clearfix"></div>
          <h4 class="text-danger" v-html="data.faq.subheading5"></h4>
          <p v-html="data.faq.bodytext5"></p>
          <h4 class="text-danger" v-html="data.faq.subheading6"></h4>
          <p v-html="data.faq.bodytext6"></p>
        </div>
        <div class="col-sm"></div>
      </div>
      <!-- Help research -->
      <div class="row" v-if="page === 'helpresearch'">
        <div class="col-sm"></div>
        <div class="col-md-8">
          <h2 class="text-primary-fh text-left" v-html="data.faq.helpresearch"></h2>
          <div class="clearfix"></div>
          <h4 class="text-danger" v-html="data.faq.subheading7"></h4>
          <p v-html="data.faq.bodytext7"></p>
          <h4 class="text-danger" v-html="data.faq.subheading8"></h4>
          <p v-html="data.faq.bodytext8"></p>
        </div>
        <div class="col-sm"></div>
      </div>
      <!-- Contact -->
      <div class="row" v-if="page === 'contact'">
        <div class="col-sm"></div>
        <div class="col-md-8">
          <p v-html="data.startpage.contactText"></p>
          <div v-if="userRegion">
            <hr />
            <p>Din region: {{userRegion}}</p>
          </div>
        </div>
        <div class="col-sm"></div>
      </div>
    </div>
    <div class="clearfix"></div>
    <br />
    <Bottom />
  </div>
</template>

<script>
import Top from '../../src/components/Top'
import Bottom from '../../src/components/Bottom'
import { request } from '../plugins/datocms'
import { getRegion } from '../plugins/regions'

export default {
  name: 'faq',
  props: ['page'],
  components: {
    Top,
    Bottom
  },
  data () {
    return {
      data: null,
      userRegion: getRegion(sessionStorage.getItem('region'))
    }
  },
  async mounted () {
    this.data = await request({
      query: `
        {
          startpage {
            contactText
          }
          faq {
            whatisfh
            howtotreatfh
            aboutapp
            helpresearch
            subheading1
            subheading2
            subheading3
            subheading4
            subheading5
            subheading6
            subheading7
            subheading8
            bodytext1
            bodytext2
            bodytext3
            bodytext4
            bodytext5
            bodytext6
            bodytext7
            bodytext8
          }
        }
      `
    })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.container {
  margin-top: 2vh !important;
  margin-bottom: 5vh;
  min-height: 60vh;
}
.img-banner {
  background-attachment: fixed;
  background-repeat: no-repeat;
  width: auto;
  min-width: 100% !important;
  height: 45vh;
  margin-top: 20vh;
}
@media screen and (max-width: 1280px) {
  .img-banner {
    margin-top: 20vh;
    width: 100vw;
    height: 30vh;
    background-attachment: scroll;
    background-repeat: no-repeat;
    background-position: center center;
  }
  .container {
    font-size: 90%;
    margin-left: 1vw;
    margin-right: 1vw;
  }
}
/* Portrait and Landscape */
@media only screen
  and (min-device-width: 300px)
  and (max-device-width: 812px) {
  h2 {
    font-size: 20px;
  }
  p {
    font-size: 14px;
  }
  .img-banner {
    object-fit: cover;
    width: 100vw;
    height: 200px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Faq.vue